import * as React from "react"
import { Col, Row } from "react-grid-system"
import styled from "styled-components"
import H4 from "../../../atoms/typography/H4"
import Counter from "../../Counter"
import BodyMedium from "../../../atoms/typography/BodyMedium"
import SmallButton from "../../../atoms/buttons/SmallButton"
import { MinusIcon } from "../../../atoms/icons/MinusIcon"

interface Props {
  imgSrc: string
  title: string
  amount: number
  onClickMinus: () => void
  onClickPlus: () => void
  onClickRemove: () => void
  price: string
}

const CircleContainer = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 2px solid #c3c3c3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  padding: 4px;
  overflow: clip;
`

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  width: 330px;
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const AddedAccessoriesRow: React.FC<Props> = ({
  imgSrc,
  title,
  amount,
  onClickMinus,
  onClickPlus,
  onClickRemove,
  price,
}) => {
  return (
    <Row nogutter align="center" justify="between">
      <ItemContainer>
        <CircleContainer>
          <Image src={imgSrc} />
        </CircleContainer>
        <H4>{title}</H4>
      </ItemContainer>
      <Counter currentValue={amount} onClickAdd={onClickPlus} onClickMinus={onClickMinus} minValue={1} />
      <BodyMedium>{price}</BodyMedium>
      <SmallButton leftIcon={<MinusIcon />} title="Remove" onClick={onClickRemove} />
    </Row>
  )
}

export default AddedAccessoriesRow
